// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb8{margin-bottom:8px}.type_tag{display:inline-block;height:32px;padding:0 10px;line-height:30px;font-size:12px;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;white-space:nowrap}.two{background:rgba(239,156,32,.1);color:#ef9c20}.one{background:rgba(75,202,213,.1);color:#4bcad5}.three{color:#7880a0;background:rgba(120,128,160,.1)}", ""]);
// Exports
module.exports = exports;
